import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';

import {BrowserRouter as Router, matchPath, Route, Switch, withRouter,} from "react-router-dom";

import * as serviceWorker from './serviceWorker';

import {Components} from './Components';

import {createStore} from "redux";
import {connect, Provider} from 'react-redux'

import AppStore from './Store/reducer'

import {Error404, Template} from "./Template";
import {APP_STATE, LOGIN_STATES, setAppState, setHeader, setLoginState, setUserData} from "./Store/actionTypes";
import {verifyCredentials} from "./Core/Authentification";
import {AppTitle} from "./Config";
import {CenteredLoader} from "./Core/LoadingAnimation";
import ContainerError, {ERROR_TYPES} from "./Template/Material-Template/ContainerError";

const store = createStore(AppStore);

function TemplateAdapter(props) {
    let [resolvedComponents, setResolvedComponents] = React.useState([]);

    React.useEffect(() => {
        document.title = AppTitle;

        Promise.all(Components).then((v) => {
            setResolvedComponents(v.map(e => e[1].default));
            setTimeout(() => {
                store.dispatch(setAppState(APP_STATE.INITIALISED));
                setTimeout(() => {
                    verifyCredentials(props.setLoginState, props.setUserData).then();
                }, 100);
            }, 100)
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let components = resolvedComponents.filter((e) => e.hasAccess(props.loginState, props.userData));

    let flattenComponents = components.reduce((c, cur) => {
        if (cur.type === 'collection') {
            return [...c, ...cur.children.filter((e) => e.hasAccess(props.loginState, props.userData))];
        } else {
            return [...c, cur];
        }
    }, []);

    return <Template components={components} currentPath={props.location.pathname}
                     accessCheck={(c) => c.hasAccess(props.loginState, props.userData)}>
        {
            props.loginState !== LOGIN_STATES.TRY_LOGIN &&
            <Routes loginState={props.loginState} components={flattenComponents} location={props.location}/>
        }
    </Template>
}

let Routes = ({loginState, components, location: {pathname}}) => {

    if (loginState === LOGIN_STATES.TRY_LOGIN)
        return null

    if (loginState === LOGIN_STATES.CONNECTION_ERROR)
        return <ContainerError type={ERROR_TYPES.CONNECTION}/>

    return <Switch> {
        components.map((e, i) => {
            let CurrentComponent = React.lazy(e.lazyLoader); // NOSONAR

            if (matchPath(pathname, e.path)) {
                store.dispatch(setHeader(e.label, e.icon));
            }

            return <Route key={i} path={e.path}>
                <Suspense fallback={<CenteredLoader/>}> <CurrentComponent/> </Suspense>
            </Route>
        })
    }
        <Route>
            <Suspense fallback={<CenteredLoader/>}> <Error404/> </Suspense>
        </Route>
    </Switch>
}

const mapStateToProps = state => {
    return {
        loginState: state.loginState,
        userData: state.userData,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setLoginState: (state) => {
            dispatch(setLoginState(state))
        },
        setUserData: (access) => {
            dispatch(setUserData(access))
        },
    }
};

const TemplateContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TemplateAdapter);

let TemplateAdapterWithRouter = withRouter(props => <TemplateContainer {...props} />);

function App() {
    return <React.StrictMode>
        <Provider store={store}>
            <Router>
                <TemplateAdapterWithRouter/>
            </Router>
        </Provider>
    </React.StrictMode>
}

ReactDOM.render(<App/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
